import React from 'react';
// import { theme } from './src/ui/theme'; // to override styles create this file
import { MantineProvider, createTheme } from '@mantine/core';
import DevCycleRoot from './src/feature-flags/devcycle-root';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './styles/global.scss';
import '@mantine/core/styles.css'; // All packages except `@mantine/hooks` require styles imports

const theme = createTheme({
  fontFamily: 'Konnect, sans-serif',
  fontFamilyMonospace: 'Konnect, monospace',
  headings: { fontFamily: 'Konnect, sans-serif' }
});

// Define reCAPTCHA onloadCallback function
if (typeof window !== 'undefined') {
  window.onloadCallback = function () {
  };
}

export const wrapPageElement = ({ element }) => {
  return <MantineProvider theme={theme}>{element}</MantineProvider>; // theme={theme}
};

export const wrapRootElement = ({ element }) => {
  return <DevCycleRoot>{element}</DevCycleRoot>;
};
